var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagerieIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "#003366"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7035 33.1104C19.0489 33.1725 19.3991 33.2036 19.75 33.2031C20.859 33.2046 21.9459 32.8925 22.8851 32.3028C23.5624 32.462 24.2711 32.5469 25 32.5469C29.6567 32.5469 33.5312 29.0731 33.5312 24.6719C33.5312 20.2706 29.6567 16.7969 25 16.7969C20.3433 16.7969 16.4688 20.2706 16.4688 24.6719C16.4688 26.7798 17.3656 28.6855 18.8085 30.0899C19.0115 30.2876 19.0509 30.4644 19.0308 30.565C18.9226 31.1093 18.6775 31.6171 18.3185 32.0403C18.244 32.1282 18.1939 32.2343 18.1735 32.3478C18.153 32.4612 18.1627 32.5781 18.2017 32.6866C18.2408 32.7951 18.3077 32.8914 18.3958 32.9658C18.4839 33.0402 18.59 33.09 18.7035 33.1104ZM21.7188 23.6875C21.4577 23.6875 21.2073 23.7912 21.0227 23.9758C20.8381 24.1604 20.7344 24.4108 20.7344 24.6719C20.7344 24.9329 20.8381 25.1833 21.0227 25.3679C21.2073 25.5525 21.4577 25.6563 21.7188 25.6563C21.9798 25.6563 22.2302 25.5525 22.4148 25.3679C22.5994 25.1833 22.7031 24.9329 22.7031 24.6719C22.7031 24.4108 22.5994 24.1604 22.4148 23.9758C22.2302 23.7912 21.9798 23.6875 21.7188 23.6875ZM24.0156 24.6719C24.0156 24.4108 24.1193 24.1604 24.3039 23.9758C24.4885 23.7912 24.7389 23.6875 25 23.6875C25.2611 23.6875 25.5115 23.7912 25.6961 23.9758C25.8807 24.1604 25.9844 24.4108 25.9844 24.6719C25.9844 24.9329 25.8807 25.1833 25.6961 25.3679C25.5115 25.5525 25.2611 25.6563 25 25.6563C24.7389 25.6563 24.4885 25.5525 24.3039 25.3679C24.1193 25.1833 24.0156 24.9329 24.0156 24.6719ZM28.2812 23.6875C28.0202 23.6875 27.7698 23.7912 27.5852 23.9758C27.4006 24.1604 27.2969 24.4108 27.2969 24.6719C27.2969 24.9329 27.4006 25.1833 27.5852 25.3679C27.7698 25.5525 28.0202 25.6563 28.2812 25.6563C28.5423 25.6563 28.7927 25.5525 28.9773 25.3679C29.1619 25.1833 29.2656 24.9329 29.2656 24.6719C29.2656 24.4108 29.1619 24.1604 28.9773 23.9758C28.7927 23.7912 28.5423 23.6875 28.2812 23.6875Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#003366"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagerieIcon);
export default __webpack_public_path__ + "static/media/messagerieIcon.1f51fa5055d079e39622f3b3dd6dcf77.svg";
export { ForwardRef as ReactComponent };